import React from "react";
import { compose } from "recompose";
import { Button } from "reactstrap";
import {
  TableContainer,
  TableDataFetch,
  AddNewButton,
  withTable,
  ViewingRecords,
} from "components/common/Tables/index";
import Page from "components/common/Page";
import { Trans } from "react-i18next";
import BackButton from "components/refactoring/BackButton";
import { DynamicTable, RemoveAllButton } from "../CoreComponents";
import LoadingMsg from "components/common/LoadingMsg";

export const ModuleList = ({
  selected,
  match,
  url = "core/hesaab_module",
  setSelected,
  ordering,
  setOrdering,
  data,
  setData,
  limit,
  offset,
  setOffset,
  search,
  setSearch,
  isDeleteModalOpen,
  toggleDeleteModal,
  t,
  onDeleted,
  refreshToken,
  readOnly,
}) => (
  <Page title="Modules" className="inv-table">
    <BackButton/>
    <div className="mb-2 d-flex justify-content-center">
      <AddNewButton
        resource="Module"
        match={match}
        className="mx-0"
        readOnly={readOnly}
      />
      <div className="mx-auto"/>
      <RemoveAllButton className="mx-0" type="Modules" t={t}/>
    </div>
    <TableContainer
      items={data.results}
      ordering={ordering}
      onOrderingChanged={setOrdering}
      selected={selected}
      onSelectedChanged={setSelected}
    >
      {data.loading ? <LoadingMsg/> : 
        <DynamicTable data={data} match={match} readOnly={readOnly} onDeleted={onDeleted} type="Module" url={url} t={t}/>
      }
    </TableContainer>
    <TableDataFetch
      ordering={ordering}
      refreshToken={refreshToken}
      search={search}
      limit={limit}
      url={url}
      offset={offset}
      onDataFetched={setData}
    />
    <ViewingRecords
      offset={offset}
      limit={limit}
      count={data.count}
      className="float-left"
    />
  </Page>
);

const enhance = compose(withTable({ limit: 999999 }));

export default enhance(ModuleList);
